import { render, staticRenderFns } from "./TicketTableBadges.vue?vue&type=template&id=36f221c0&scoped=true&"
import script from "./TicketTableBadges.vue?vue&type=script&lang=js&"
export * from "./TicketTableBadges.vue?vue&type=script&lang=js&"
import style0 from "./TicketTableBadges.vue?vue&type=style&index=0&id=36f221c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f221c0",
  null
  
)

export default component.exports